module.exports = function(app) {
    app.controller("pages.spending.spendingClaims", ["$scope", "session","services", "storage","coremetrics","spendingResourceServices","$q","$cookies","invisibleForm",'spendingAccountsService', '$window','$timeout','$filter','$location',
        function( $scope, session, services, storage, coremetrics, spendingResourceServices,$q, $cookies, invisibleForm, spendingAccountsService, $window, $timeout,$filter,$location) {

            $scope.spendingClaimsList = [];
            $scope.loadClaims=false;

            $scope.continueToClaims = function() {
                $window.location = '/member/claims/claimsAndPayments';
            };

            $scope.submitClaims = function() {
                sessionStorage.incomingUrl = "claim";
                $window.location = '/member/spending/clientListSelection';
            };


            var setUpRefineDateRange =function(){
                var createDateRange = function(startDaysAgo, endDaysAgo) {
                    startDate = $filter('date')(new Date() - startDaysAgo*60*60*24*1000, 'yyyyMMdd')
                    endDate = endDaysAgo
                        ? $filter('date')(new Date() - endDaysAgo*60*60*24*1000, 'yyyyMMdd')
                        : $filter('date')(new Date(), 'yyyyMMdd');
                    return JSON.stringify({ startDate: startDate, endDate: endDate });
                };
                $scope.sidebar.spendingClaimsDateRange = createDateRange(365);
                $scope.sidebar.spendingClaimsDateRangeOptions = [
                    { label: "Last 12 Months", value: createDateRange(365) },
                    { label: "Last 6 Months", value: createDateRange(183) },
                    { label: "Last 90 Days", value: createDateRange(90) },
                    { label: "Last 60 Days", value: createDateRange(60) },
                    { label: "Last 30 Days", value: createDateRange(30) }

                ];

                $scope.$watch('sidebar.spendingClaimsDateRange', function(r) {
                    for (var i = 0, options = $scope.sidebar.spendingClaimsDateRangeOptions, value; i < options.length; i++) {
                        value = options[i].value;

                        if (value === r) {
                            if (i < 5) {
                                options.splice(5, 1);
                            }
                        }
                    }
                    $scope.fetchSpendingClaims($scope.sidebar.spendingClaimsDateRange);
                });

            };

            var dateCompare = function(compareDate, endDate) {
                while(compareDate.indexOf("/") != -1) {
                    compareDate = compareDate.replace("/", "-");
                }
                while(endDate.indexOf("/") != -1) {
                    endDate = endDate.replace("/", "-");
                }
                var compDt = new Date(compareDate).getTime();
                var dt = new Date(endDate).getTime();

                if(compDt > dt) return 1;
                if(compDt == dt) return 0;
                if(compDt < dt) return -1;
            };

            var triggerHasMoreRecordsCalls = function(results, getParams, isReceiptRequired){
                var requests = [];
                var deferred;
                var baseResponse;
                var hasMoreRecords;
                var claimActivityList = [];
                var clientNumbers = [];

                clientNumbers = spendingAccountsService.spendingAccountClients();
                results.forEach(function(client){
                    baseResponse = client.data.repGetClaimActivitiesReply.payload.repGetClaimActivitiesData;
                    claimActivityList = baseResponse.claimActivityList.claimActivity;
                    hasMoreRecords = baseResponse.hasMoreRecords;

                    //SPA Refine Enhancement - Adding sort method to sort by submit date
                    claimActivityList.sort(function(claimA, claimB){
                        var date1 = claimA.submitDate;
                        var date2 = claimB.submitDate;
                        return dateCompare(date1, date2);
                    });

                    //To display the latest claims first
                    claimActivityList.reverse();
                    var i=0;
                    claimActivityList.forEach(function(claim){
                        var index=i++;
                        if (isReceiptRequired) {
                            receiptRequiredList.push(claim.claimID);
                        } else {
                            claim.groupCode = clientNumbers[index-1];
                            $scope.spendingClaimsList.push(claim);
                        }
                    });

                    if(hasMoreRecords === "Yes"){
                        getParams.participantCode = baseResponse.participantCode;
                        getParams.startAfterSeqID = baseResponse.highestSequenceID;
                        getParams.groupCode = clientNumbers[pos];

                        var servicePromise = services.dpsext.getClaimActivityV2().fetch(getParams);

                        requests.push(servicePromise);
                    }
                });

                if(requests.length > 0){
                    $q.all(requests).then(function(results){
                        triggerHasMoreRecordsCalls(results, getParams, isReceiptRequired);
                    });
                } else if (isReceiptRequired) {
                   // buildSpendingClaimsView(currentFromServiceDate);
                } else {
                    $scope.loadClaims=true;
                    //spendingClaimsWidget.loadData(spendingClaimsList, receiptRequiredList);
                    //var filterOnLoad = isClaimFilter ? false : true;
                    //buildRefineContentSpendingClaims(spendingClaimsList, filterOnLoad);
                }
            };


            $scope.fetchSpendingClaims =function(dateRange){
                var transactionPromises =[];
                var isClaimFilter = false;
                dateRange = JSON.parse(dateRange || createDateRange(30));
                var startDate = dateRange.startDate.substr(4,2) + '/' + dateRange.startDate.substr(6,2) + '/' + dateRange.startDate.substr(0,4);
                endDate =dateRange.endDate.substr(4,2) + '/' + dateRange.endDate.substr(6,2) + '/' + dateRange.endDate.substr(0,4);

                var getParams = {};
                getParams.participantCode = session.data.memberInfo.umi+'0';
                getParams.startOfServiceBegin=startDate;
                if(endDate){

                    var endDateTime = endDate?new Date(endDate).getTime():new Date().getTime();
                    var endDateModified = new Date(endDateTime + 60*24*60*60*1000);
                    getParams.endOfServiceBegin =$filter('date')(endDateModified, 'MM/dd/yyyy');
                }
                var claimFilter = storage.get("claimFilter") || null, receiptPath = "";
               // var locationHash = (($location.url.indexOf('debit') > -1) || ($location.url.indexOf('manual') > -1)) ? true : false;
                /*if (locationHash) {
                    if ($location.url.indexOf('debit') > -1){
                        receiptPath = "debit";
                    } else if (location.url.indexOf('manual') > -1) {
                        receiptPath = "manual";
                    }
                }*/
                if ( claimFilter != null ) {
                    switch (claimFilter.data) {
                        case "OnlineClaimsRecptReqd":
                            getParams.receiptRequired = "Yes";
                            getParams.receiptRequiredType = "Online";
                            break;
                        case "RecReqForDBCardsClaims":
                            getParams.receiptRequired = "Yes";
                            getParams.receiptRequiredType = "Debitcard";
                            break;

                        case ("DeniedClaims"):
                            getParams.claimStatus = "Denied";
                            // we need this to make a decision to show a widget or not in spendingClaimsWidget.js
                            storage.set("isDenied", true);
                            break;
                    }

                    //take 2 years to be sure ALL recpt required or denied claims are shown
                    var allBeginDateRange = new Date();
                    allBeginDateRange.setFullYear(allBeginDateRange.getFullYear() - 2);
                    getParams.startOfServiceBegin = $filter('date')(allBeginDateRange, 'MM/dd/yyyy');

                    //don't do the search/filter again
                    storage.set("claimFilter", null);

                    //lidr9hl - flag for claim filter
                    isClaimFilter = true;
                }

                    //do we have a receipt required path parameter to account for?
                    if (receiptPath) {
                        var allBeginDateRange = new Date();
                        allBeginDateRange.setFullYear(allBeginDateRange.getFullYear() - 2);
                        getParams.startOfServiceBegin = $filter('date')(allBeginDateRange,'MM/dd/yyyy');
                        if (receiptPath === "debit"){
                            getParams.receiptRequired = "Yes";
                            getParams.receiptRequiredType="Debitcard";
                        } else if (receiptPath === "manual") {
                            getParams.receiptRequired = "Yes";
                            getParams.receiptRequiredType="Online";
                        }
                        receiptPath = "";
                    }

                    getParams.noOfRec = "99";
                    var lengthClaimActivities = 0;
                    var spendingAccountExist = false;
                    var isAllPassThru = false;
                    //var getClaimActivityV2
                   // var servicePromises = spaUtil.handlingMultipleClients('getClaimActivityV2', "GET", getParams, true);
                    //var servicePromises = services.dpext.getClaimActivityV2().fetch(getParams);
                    var servicePromisesArray=[];
                    var lengthClaimActivities = 0;
                    var isAllPassThru = false;
                    var spendingAccountExist = false;
                    var spendingAccountClient =spendingAccountsService.spendingAccountClients();
                    if(spendingAccountClient && spendingAccountClient.length>0){
                        //getParams.groupCode = spendingAccountClient[0];
                        spendingAccountClient.forEach(function(client){
                            getParams.groupCode = client;
                            var servicePromise = services.dpsext.getClaimActivityV2().fetch(getParams);
                            servicePromisesArray.push(servicePromise);
                        });
                    };
                    if(servicePromisesArray.length>0){
                        $q.all(servicePromisesArray).then(function(results){
                            console.log(results);
                            if(results.length > 0){
                                results.forEach(function(client){
                                    lengthClaimActivities += client.data.repGetClaimActivitiesReply.payload.repGetClaimActivitiesData.claimActivityListCount;
                                });
                                if(lengthClaimActivities > 0) {
                                    isAllPassThru = isAllPassThruorOther(results);
                                    if (!isAllPassThru) {
                                        spendingAccountExist = true;
                                        /*domClass.remove(amountSectionNode, "display-none");
                                         domClass.remove(statusSectionNode, "display-none");
                                         domClass.remove(receiptRequiredSectionNode, "display-none");
                                         domClass.remove(typesSectionNode, "display-none");
                                         domClass.remove(acctTypeSectionNode, "display-none");
                                         domClass.add(noClaimsDescNode, "display-none");*/
                                    }


                                    if (isAtLeastOnePassThru(results)) {
                                        // At least one pass thru claim, show the denied/passthru widget
                                        // showPassThruWidget();

                                        // There is one pass, are all of the claims pass thru?
                                        if (isAllPassThru) {
                                            //domConstruct.place("<hr class='thick'><br />" + staticContentObject.spendingClaims_widget_noClaimsSelected, noClaimsDescNode, "only");
                                            ////noClaimsDescNode.innerHTML = "<hr class='thick'><br />" + staticContentObject.spendingClaims_widget_noClaimsSelected;
                                            //domClass.remove(noClaimsDescNode, "display-none");
                                            //hideDownloadButton();
                                        }
                                    } else {
                                        // We have claims but no pass thru claims, check if there are any pending pass thru claims.
                                        getPendingPassThruClaims(startDate, endDate);
                                    }
                                    triggerHasMoreRecordsCalls(results, getParams, false);
                                }else{
                                    getPendingPassThruClaims(startDate, endDate);
                                }
                            }
                        });
                    }
                    console.log("check");

                };

            var isAllPassThruorOther = function(data) {

                var passThruOk = false;
                var counterOne = 0;
                var counterTwo = 0;
                var baseResponse;
                var claimActivityList = [];

                data.forEach(function(client){
                    baseResponse = client.data.repGetClaimActivitiesReply.payload.repGetClaimActivitiesData;
                    claimActivityList = baseResponse.claimActivityList.claimActivity;

                    claimActivityList.forEach(function(claim){
                        if(claim.claimSubType== "Pass Thru" && claim.claimType == "Pass Thru") {
                            counterOne++;
                        }
                        counterTwo++;
                    });
                });

                if (counterTwo == 0) {
                    passThruOk = false;
                } else {
                    counterOne==counterTwo ? passThruOk=true : passThruOk = false;
                }
                return passThruOk;
            };

             var  isAtLeastOnePassThru = function(data) {

                    var passThruOk = false;
                    var baseResponse;
                    var claimActivityList = [];

                     data.forEach(function(client){
                        baseResponse = client.data.repGetClaimActivitiesReply.payload.repGetClaimActivitiesData;
                        claimActivityList = baseResponse.claimActivityList.claimActivity;

                         claimActivityList.forEach(function(claim){
                            if(claim.claimSubType == "Pass Thru" && claim.claimType == "Pass Thru") {
                                passThruOk = true;
                            }
                        });
                    });

                    return passThruOk;
             };

            var getPendingPassThruClaims = function(startServiceDate, endServiceDate) {
                var getParams = {};

                getParams.includePassThru = "Yes";
                getParams.returnProcessedPassthruClaims = "Yes";
                getParams.includeIgnored = "Yes";
                getParams.claimSource = "Passthru";
                getParams.noOfRec = "99";
                getParams.startOfServiceBegin = startServiceDate;
                getParams.participantCode = session.data.memberInfo.umi+'0';

                if(endServiceDate){
                    getParams.endOfServiceBegin = endServiceDate;
                }
                var servicePromisesArray=[];
                var spendingAccountClient =spendingAccountsService.spendingAccountClients();
                if(spendingAccountClient && spendingAccountClient.length>0){
                    //getParams.groupCode = spendingAccountClient[0];
                    spendingAccountClient.forEach(function(client){
                        getParams.groupCode = client;
                        var servicePromise = services.dpsext.getClaimActivityV2().fetch(getParams);
                        servicePromisesArray.push(servicePromise);
                    });
                };
                if(servicePromisesArray.length>0){
                    $q.all(servicePromisesArray).then(function(passThruResults){
                        var numOfPassThruClaims = 0;
                        passThruResults.forEach(function(client){
                            numOfPassThruClaims += client.data.repGetClaimActivitiesReply.payload.repGetClaimActivitiesData.claimActivityListCount;
                        });

                        if (numOfPassThruClaims > 0) {
                            //showPassThruWidget();
                        }
                    });
                }


               // return passThruPromise;
            };







            setUpRefineDateRange();
        }])
};